import React, { useState } from "react";
import { FaArrowLeft, FaCheckCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import { apiPut } from "../../API/Api_Url";

const MakeRequirementCompletedModel = ({ requirementData, isOpen, onClose, GetUserAllPendingRequirements }) => {
    const [IsLoading, setIsLoading] = useState(false);

    const handleConfirm = async () => {
        try {
            setIsLoading(true);

            const payload = {};
            const response = await apiPut(
                `/api/user/MakeRequirementCompleted/${requirementData?._id}`,
                payload
            );

            if (response?.data) {
                toast.success("Requirement marked as completed!");
                onClose();
                GetUserAllPendingRequirements();
            } else {
                toast.error(response?.message || "Failed to update requirement status");
            }
        } catch (error) {
            console.error("Error completing requirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full">
                <div className="flex items-center mb-6">
                    <FaArrowLeft
                        className="mr-3 cursor-pointer text-gray-600 hover:text-gray-800 transition"
                        onClick={onClose}
                    />
                    <h2 className="text-xl font-semibold text-gray-800">Confirm Completion</h2>
                </div>

                <div className="text-center">
                    <FaCheckCircle className="text-green-500 text-5xl mx-auto mb-4" />
                    <p className="text-gray-700 text-lg font-medium">
                        Do you want to mark this requirement as <span className="font-semibold">Completed</span>?
                    </p>
                    <p className="text-red-500 text-sm mt-2">
                        ⚠️ You cannot undo this action once confirmed.
                    </p>
                </div>

                <div className="flex justify-between mt-8 gap-4">
                    <button
                        onClick={onClose}
                        disabled={IsLoading}
                        className="w-1/2 py-2 rounded-full font-medium border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={IsLoading}
                        className={`w-1/2 py-2 rounded-full font-medium text-white transition 
                            ${IsLoading ? "bg-gray-400 cursor-not-allowed" : "bg-gradient-to-r from-green-500 to-blue-500 hover:opacity-90"}`}
                    >
                        {IsLoading ? "Updating..." : "Yes, Complete"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MakeRequirementCompletedModel;
